import axios from 'axios';
import {getItem} from '../utils/storage';
import moment from 'moment-timezone';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

export function loading(){

}

export function setCallForwardData(data){
    return {
        type: 'SET_CALL_FORWARD',
        payload: data
    };
}

function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function handleResponseParallel(response1, response2){
  if(response1.status==200 && response2.status==200){
    let returnData = {};
    if(response1.data.status && response2.data.status){
      returnData = response1
    }else if(!response1.data.status && response2.data.status){
      returnData = response1;
    }else if(response1.data.status && !response2.data.status){
      returnData = response2;
    }
    return returnData;
  }else{
    let error = new Error(response1.statusText);
    error.response1 = response1;
    throw error;
  }
}

function inconditionalDivert(){
  return getV2AxiosInstance()
  .post("/bridge/en/invoxapi/Agent", {
    action: "getStatusCallForward",
    params: { agent_id: localStorage.getItem("agent_id"),
    timestamp: moment().unix(),
   },
  })
}

function conditionalDivert(){
  return getV2AxiosInstance()
  .post("/bridge/en/invoxapi/Agent", {
    action: "getConditionalCallForward",
    params: { agent_id: localStorage.getItem("agent_id"),
    timestamp: moment().unix(),
   },
  })
}

export function getCallForward(){
    let incondData, condData;
    return dispatch => {
      dispatch({
          type: 'SET_LOADING',
          payload: true
      })
      return axios.all([inconditionalDivert(), conditionalDivert()])
      .then(axios.spread(function (incond, cond) {
        if (
          incond.data.response.items &&
          cond.data.response.items
        ) {
          incondData = incond.data.response.items[0];
          condData = cond.data.response.items[0];
          dispatch({
            type: 'SET_LOADING',
            payload: false
        })
        dispatch(setCallForwardData(Object.assign(incondData, condData)));
        return handleResponse(incond);
        }}))
    };
}

export function setInconditionalDivert(payload){
  return dispatch => {
    return getV2AxiosInstance().post("/bridge/en/invoxapi/Agent", {
      action: "setCallForward",
      params: {
        agent_id: localStorage.getItem("agent_id"),
        call_forward_phone: payload.phone,
        call_forward: payload.call_forward == true ? Number(1) : Number(0),
        timestamp: moment().unix(),
      },
    }).then(data => {
      return handleResponse(data);
    });
  }
}

export function setConditionalDivert(payload){
  return dispatch => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "setConditionalCallForward",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          busy_phone: payload.busy_phone_call_forward,
          busy_call_forward:
            payload.busy_call_forward == true ? Number(1) : Number(0),
          no_answer_time: payload.noanswer_time_call_forward,
          no_answer_phone: payload.noanswer_phone_call_forward,
          noanswer_call_forward:
            payload.noanswer_call_forward == true ? Number(1) : Number(0),
          timestamp: moment().unix(),
        },
      })
      .then((data) => {
        return handleResponse(data);
      });
  }
}

// export function setCallForward(payload){
//     return dispatch => {
//         return axios.all([setInconditionalDivert(payload), setConditionalDivert(payload)])
//         .then(axios.spread(function (incond, cond) {
//           return handleResponseParallel(incond, cond);
//         }))
//     };
// }



// WEBPACK FOOTER //
// ./src/actions/callForward.js